const initHeaderScroll = () => {
  const header = document.querySelector('.header');

  if (!header) {
    return;
  }

  let didScroll;
  let lastScrollTop = 0;
  let delta = 10;
  let navbarHeight = header.offsetHeight;

  window.addEventListener('scroll', function () {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 10);

  function hasScrolled() {
    let st = window.scrollY;

    if (Math.abs(lastScrollTop - st) <= delta) {
      return;
    }

    if (st > lastScrollTop && st > navbarHeight) {
      header.classList.add('header--scrolling-up');
      header.classList.remove('header--scrolling-down');
    } else {
      if (st + window.innerHeight < document.body.offsetHeight) {
        header.classList.remove('header--scrolling-up');
        header.classList.add('header--scrolling-down');
      }
    }

    lastScrollTop = st;
  }
};

export default initHeaderScroll;
